import { render, staticRenderFns } from "./date-input.vue?vue&type=template&id=65f58738&"
import script from "./date-input.vue?vue&type=script&lang=ts&"
export * from "./date-input.vue?vue&type=script&lang=ts&"
import style0 from "./date-input.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports